module.exports = __webpack_public_path__ + "assets/img/book-account.28ac4e47.svg";